// extracted by mini-css-extract-plugin
export default {"wrapper":"EmojiPicker-module__wrapper___X1L9d","icon":"EmojiPicker-module__icon___BNuyL","remove":"EmojiPicker-module__remove___wMpE4"};